import React, { useEffect } from "react";
import { Redirect, useLocation } from "react-router-dom";
import { Grid, Typography, Button } from "@deere/fuel-react";
import SupplierData2 from "./SupplierData2";
import ButtonSection from "./ButtonSection";
import { useOktaAuth } from "@okta/okta-react";
import { ERR_DESC_REQUEST_NUMBER, ERR_TITLE_REQUEST_NUMBER } from "../../utils/errorLiterals";
import { ReactComponent as PrintIcon } from "@deere/ux.brand-foundations/icons/print.svg";
import { getDateFromTimeStamp } from "../../utils/utils"
import { NON_OKTA_USER } from "../../utils/surveyLiterals";

const STReview = (props) => {
  const location = useLocation();
  const { authState } = useOktaAuth();
  const supplierName = location.state ? location.state.supplierName : "";
  const supplierNo = location.state ? location.state.supplierName.split(" - ")[0] : "";
  const previous = location.state ? location.state.previous : "";
  const rn = location.state ? (location.state.rn ? location.state.rn : (location.state.queryParam ? location.state.queryParam : "")) : "";
  let isAuthMethodOkta = authState && authState.isAuthenticated ? true : false;
  let nonOktaAuthFailed = !isAuthMethodOkta ? (location.state && location.state.isAuthNonOkta ? false : true) : false;
  const endDate = location.state && location.state.endDate ? getDateFromTimeStamp(new Date(location.state.endDate)) : "";
  let updatedBy = location.state && location.state.campaign && location.state.campaign.updatedBy && location.state.campaign.updatedBy !== NON_OKTA_USER ? location.state.campaign.updatedBy : "";
  let updatedOn = location.state && location.state.campaign && location.state.campaign.updatedts ? getDateFromTimeStamp(new Date(location.state.campaign.updatedts)) : "";

  if (previous === "/details") {
    let assignmentUpdateDetails = [];
    if (location.state && location.state.campaign && location.state.campaign.assignmentUpdateDetails) {
      assignmentUpdateDetails = location.state.campaign.assignmentUpdateDetails.find((item) => item.id === rn);
    }
    updatedBy = assignmentUpdateDetails.updatedBy ? assignmentUpdateDetails.updatedBy : "";
    updatedOn = assignmentUpdateDetails.updatedTs ? getDateFromTimeStamp(new Date(assignmentUpdateDetails.updatedTs)) : "";
  }

  const displayErrorCard = () => {};
  const displaySaveAlert = () => {};
  window.scrollTo(0, 0);

  useEffect(() => {
    if (window.location.pathname === "/streviewext") props.setShowHeaderFooter(false);
  }, []);

  if (nonOktaAuthFailed) {
    return (
      <Redirect
        to={{
          pathname: "/error",
          state: { errorTitle: ERR_TITLE_REQUEST_NUMBER, errorDescription: ERR_DESC_REQUEST_NUMBER },
        }}
      />
    );
  }
  return (
    <Grid container>
      <Grid item xs={12} mt={4}>
        <Typography variant="h1" fontWeight="regular">
          Sub-Tier (ST) Survey
        </Typography>
      </Grid>
      <Grid item xs={10} mb={6}>
        <Typography variant="h5" gutterBottom>
          Current request {rn} - {supplierName}
        </Typography>
        {endDate !== "" && (
          <Typography variant="h5" gutterBottom>
            Due date {endDate}
          </Typography>
        )}
        {updatedOn !== "" && (
          <Typography variant="h5" gutterBottom>
            Last saved on {updatedOn} {updatedBy !== "" ? "by " + updatedBy : ""}
          </Typography>
        )}
      </Grid>
      <Grid item container xs={2} justifyContent="flex-end" className="d-print-none" alignItems={"flex-end"} alignContent={"flex-end"} paddingRight={4} style={{ textAlign: "right", display: "flex" }}>
        <Button variant="secondary" onClick={() => window.print()}>
          <PrintIcon size="sm" /> Print
        </Button>
      </Grid>
      <Grid item xs={12} mb={6}>
        <SupplierData2 supplierId={supplierNo} displayErrorCard={displayErrorCard} showActions={false} isAuthMethodOkta={isAuthMethodOkta} />
      </Grid>
      <Grid item xs={12} style={{ position: "sticky", bottom: 0 }} className="d-print-none">
        <ButtonSection
          supplierId={supplierNo}
          displayErrorCard={displayErrorCard}
          displaySaveAlert={displaySaveAlert}
          showActions={false}
          prev={previous}
          rn={rn}
          isAuthMethodOkta={isAuthMethodOkta}
        />
      </Grid>
    </Grid>
  );
};

export default STReview;
